import { ActionTypes } from "../constants/action-types"
const initialState = {
    viditelnost: [],
    pouziti: [],
    klasifikace: [],
    rodinyPovrchu: [],
    rodinyVybaveni: []
}
export const miscReducer = (state=initialState, {type, payload}) => {
    switch(type) {
        case ActionTypes.SET_VIDITELNOST:
            return { ...state, viditelnost: payload };
        case ActionTypes.SET_POUZITI:
            return { ...state, pouziti: payload };
        case ActionTypes.SET_KLASIFIKACE:
            return { ...state, klasifikace: payload };  
        case ActionTypes.SET_RODINYPOVRCHU:
            return { ...state, rodinyPovrchu: payload };     
        case ActionTypes.SET_RODINYVYBAVENI:
            return { ...state, rodinyVybaveni: payload};               
        default:
            return state            
    }
} 